import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { User, Link2, Palette, QrCode, Crown, Users, History, MessageCircle } from 'lucide-react';

import ProfileSettings from './ProfileSettings';
import StoreSlug from './StoreSlug';
import ThemeCustomization from './ThemeCustomization';
import QRCodePage from './QRCodePage';
import Subscription from './Subscription';
import TeamMembers from './TeamMembers';
import ActivityLog from './ActivityLog';
import WhatsAppAlerts from './WhatsAppAlerts';

const TABS = [
  { value: 'account', label: 'Account', icon: User, render: () => <ProfileSettings /> },
  { value: 'team', label: 'Team', icon: Users, render: () => <TeamMembers /> },
  { value: 'activity', label: 'Activity', icon: History, render: () => <ActivityLog /> },
  { value: 'store-link', label: 'Store Link', icon: Link2, render: () => <StoreSlug /> },
  { value: 'theme', label: 'Store Theme', icon: Palette, render: () => <ThemeCustomization /> },
  { value: 'qr-code', label: 'QR Code', icon: QrCode, render: () => <QRCodePage /> },
  { value: 'whatsapp', label: 'WhatsApp Alerts', icon: MessageCircle, render: () => <WhatsAppAlerts /> },
  { value: 'subscription', label: 'Subscription', icon: Crown, render: () => <Subscription /> },
];

const ManageStore = ({ tab }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = tab || searchParams.get('tab') || 'account';
  const initial = TABS.some((t) => t.value === requested) ? requested : 'account';

  const handleChange = (value) => {
    if (value === 'account') {
      setSearchParams({}, { replace: true });
    } else {
      setSearchParams({ tab: value }, { replace: true });
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight" data-testid="manage-store-title">
          Manage Store
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Your account, store link, theme, QR code and subscription — all in one place.
        </p>
      </div>

      <Tabs defaultValue={initial} onValueChange={handleChange} className="w-full">
        <TabsList className="flex h-auto w-full justify-start gap-1 overflow-x-auto rounded-xl p-1 no-scrollbar">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <TabsTrigger
                key={t.value}
                value={t.value}
                className="gap-2 px-3 py-2 whitespace-nowrap"
                data-testid={`manage-tab-${t.value}`}
              >
                <Icon className="h-4 w-4 flex-shrink-0" />
                <span>{t.label}</span>
              </TabsTrigger>
            );
          })}
        </TabsList>

        {TABS.map((t) => (
          <TabsContent key={t.value} value={t.value} className="mt-6">
            {t.render()}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};

export default ManageStore;
